import { StringObjectDictionary, StringStringDictionary } from "./Types";

export const Helpers = {
    delay: async (ms: number) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}

export const DataHelper = {
    getAnyAsArray: (e: any): string[] => {
        if (Array.isArray(e)) {
            return e;
        }

        if (e?.startsWith("[\"")) {
            let narr = [];
            try {
                narr = JSON.parse(e as string);
            } catch (e) {
                narr = [e];
            }
            return narr;
        }
        return [];
    },
    arrayToStringStringObject: (e: string[] | undefined): StringStringDictionary => {
        let c: StringStringDictionary = {};
        if (!!e) {
            e.filter(n => !!n).forEach((n: string) => c[n] = n);
        }
        return c;
    },
    isGuid: (g: string | undefined) => {
        if (!!g) {
            var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
            var match = regex.exec(g);
            return match != null;
        }
        return false;
    },
    isEmail: (e: string | undefined) => {
        const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        const searchfind = regexp.test(e ?? "");
        return searchfind;
    },
    arraySum: (items: number[]) => {
        return items.reduce((partialSum, a) => partialSum + a, 0);
    },
    toPercentString: (dividend: number, divisor: number, percentDecimals: number) => {
        if (divisor > 0) {
            let n = (dividend / divisor);
            const m = Math.pow(10, percentDecimals);
            return (Math.round(100 * n * m) / m) + " %";
        }

    }
}